import { OTHER_OPTION_ID } from './constants';

export const hasOther = (options: string[]) => options?.includes(OTHER_OPTION_ID);

export const skipOther = (options: string[]) => options?.filter(optionId => optionId !== OTHER_OPTION_ID) || [];

export const normalizeOptionOrder = (options: string[]) => {
  const containsOther = hasOther(options);
  const optionsWithoutOther = skipOther(options);

  return containsOther ? [...optionsWithoutOther, OTHER_OPTION_ID] : optionsWithoutOther;
};
